import React, { useContext, useState } from 'react'
import AllComp from '../components/AllComp'
import { apivalue } from '../Data/AllData';
import { Link } from 'react-router';

function AllProducts() {
    const data = useContext(apivalue);
    const [search, setSearch] = useState(0);
    const getsearch = (event) => {
        setSearch(event.target.value);
    }
    return (
        <div>
            <AllComp />;
            <div className="section properties">
                <div className='container'>
                    <div className='row properties-box'>
                        <div className='col-md-12'>
                            <input type='text' className='form-control mb-4' placeholder='Search' onChange={getsearch}></input>
                        </div>
                        {data.map((item) => {
                            return search == 0 ? (
                                <div className="col-lg-4 col-md-6 align-self-center mb-30 properties-items col-md-6 adv">
                                    <div className="item">
                                        <a>
                                            <img src={item.images[0]} alt="" />
                                        </a>
                                        <span className="category">{item.category}</span>
                                        <h6>${item.price}</h6>
                                        <h4>
                                            <a href="property-details.html">
                                                {item.title}
                                            </a>
                                        </h4>

                                        <div className="main-button">
                                            <Link to={`/Singleproduct/${item.id}`}>Details</Link>
                                        </div>
                                    </div>
                                </div>

                            ) : item.id == search ? (
                                <div className="col-lg-4 col-md-6 align-self-center mb-30 properties-items col-md-6 adv">
                                    <div className="item">
                                        <a href="property-details.html">
                                            <img src={item.images[0]} alt="" />
                                        </a>
                                        <span className="category">{item.category}</span>
                                        <h6>${item.price}</h6>
                                        <h4>
                                            <a href="property-details.html">
                                                {item.title}
                                            </a>
                                        </h4>

                                        <div className="main-button">
                                            <Link to={`/Singleproduct/${item.id}`}>Details</Link>
                                        </div>
                                    </div>
                                </div>

                            ) : item.title.toLowerCase().includes(search.toLowerCase()) ? (
                                <div className="col-lg-4 col-md-6 align-self-center mb-30 properties-items col-md-6 adv">
                                    <div className="item">
                                        <a href="property-details.html">
                                            <img src={item.images[0]} alt="" />
                                        </a>
                                        <span className="category">{item.category}</span>
                                        <h6>${item.price}</h6>
                                        <h4>
                                            <a href="property-details.html">
                                                {item.title}
                                            </a>
                                        </h4>

                                        <div className="main-button">
                                            <Link to={`/Singleproduct/${item.id}`}>Details</Link>
                                        </div>
                                    </div>
                                </div>

                            ) : null
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AllProducts
